import { useNavigate } from "react-router-dom";
import State from "../Stats/State";
import api from "../../api/api";
import { useState } from "react";
import ValidationModal from './../Owners/Demande';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCrow, faCrown, faEnvelope, faMapMarker, faPhone, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import Confirm from './../Modal/Alert/confirm';
import SuspendClient from "../../Screen/Proprietaires/Suspend";
import AbstractModal from "../Modal/Abstract";
import AddToPremium from "./AddToPremium";

export default function PrOprietaire({ observed, detail }) {
    // if (!detail) return <div>Loading...</div>;

    const nav = useNavigate()
    const [verifiedValue, setVerifiedValue] = useState(detail.owner.isVerified)
    const [open, setOpen] = useState(false)
    const [openSus, setOpenSus] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [confirmation, setShowConfirmation] = useState(false)
    const [showPremiumModal, setPremiumModal] = useState(false)

    const verified = async  (value)=>{

        try {
                        
            await api.post('/owners/verified', {
                id : detail.owner.id,
                value : true
            })
            
            setVerifiedValue(value)
            window.location.reload();
            
        } catch (error) {
            
            console.log(error)
            
        }

    }

    const unSuspening = async ()=>{

        try{

            await api.post('/owners/unsuspend', {
                clientId : detail.owner.client.id,
            })
            
            window.location.reload();
            
        }catch(e){

            console.log(e)

        }
    }

    return (
        <div className="p-6 bg-white rounded-lg shadow-lg md:p-12 dark:bg-gray-800">
            {/* Section Propriétaire */}
            <div className="mb-8">
                <div className="flex flex-row flex-wrap justify-between">
                    <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-200">Propriétaire</h3>

                    <div className="flex items-center space-x-4">                        
                        <span
                            className="px-4 py-1 font-bold text-white bg-purple-700 rounded-lg cursor-pointer hover:bg-purple-800"
                            onClick={() => setOpen(true)}
                        >
                            Voir la demande
                        </span>

                        {/* Suspendre si vérifié */}
                        {(detail.owner.isVerified && detail.owner.suspened === false) && (
                            <span
                            className="px-4 py-1 font-bold text-white bg-red-700 rounded-lg cursor-pointer hover:bg-red-800"
                            onClick={()=>setOpenSus(true)}
                            >
                            Suspendre
                            </span>
                        )}

                        {(detail.owner.isVerified && detail.owner.suspened === true && !confirmation) && (
                            <span
                            className="px-4 py-1 font-bold text-white bg-green-700 rounded-lg cursor-pointer hover:green-red-800"
                            onClick={()=>setShowConfirmation(true)}
                            >
                                Debloquer
                            </span>
                        )}

                    </div>
                </div>
                <p className="mt-3 text-gray-600 dark:text-gray-200">
                    {detail.owner.client.bio ? detail.owner.client.bio : 'Aucune description du propriétaire'}
                </p>
            </div>

            {/* Informations Propriétaire avec Image et Détails */}
            <div className="flex flex-col items-center gap-4 md:flex-row ">
                {/* Image Propriétaire */}
                <div className="flex-shrink-0">
                <img
                    alt={detail.owner.client.firstname}
                    src={detail.owner.client.picture ? `${process.env.REACT_APP_API_PICTURE_URL}${detail.owner.client.picture}` : "https://randomuser.me/api/portraits/men/86.jpg"}
                    className="object-cover w-32 h-32 rounded-full shadow-lg md:w-48 md:h-48"
                />
                </div>

                {/* Détails Propriétaire */}
                <div className="flex flex-col items-center md:items-start">

                    <div className="flex flex-row items-center space-x-3">
                        <p className="text-2xl font-bold text-gray-800 dark:text-gray-200">
                            {detail.owner.client.firstname} 
                            {detail.owner.client.lastname}
                        </p>

                        <span className={`px-4 py-1 font-bold ${detail.owner.isVerified ? 'text-green-800 bg-green-200 text-sm' : 'text-gray-800 bg-gray-200 animate-pulse text-sm'} rounded-xl`}>
                            {detail.owner.isVerified ? (
                            <>
                                <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />
                                Vérifié
                            </>
                            ) : (
                            <>
                                <FontAwesomeIcon icon={faTimesCircle} className="mr-1" />
                                Non vérifié
                            </>
                            )}
                        </span>

                        <span onClick={()=>setPremiumModal(true)} className="px-4 py-1 bg-yellow-400 rounded-lg cursor-pointer text-yellow-50 hover:bg-yellow-500">
                            <FontAwesomeIcon icon={faCrown} className="px-2"/>
                            premium
                        </span>
                    </div>
                    <div className="my-5 space-y-3">
                        {/* Téléphone */}
                        <div className="flex items-center">
                            <FontAwesomeIcon icon={faPhone} className="mr-2 text-indigo-600" />
                            <span className="text-lg font-medium text-gray-800 dark:text-gray-200">Téléphone :</span>
                            <span className="ml-2 text-gray-600 dark:text-gray-200">{detail.owner.client.phone}</span>
                        </div>
                        {/* Email */}
                        <div className="flex items-center">
                            <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-indigo-600" />
                            <span className="text-lg font-medium text-gray-800 dark:text-gray-200">Email :</span>
                            <span className="ml-2 text-gray-600 dark:text-gray-200">{detail.owner.client.email}</span>
                        </div>
                        {/* Adresse */}
                        <div className="flex items-center">
                            <FontAwesomeIcon icon={faMapMarker} className="mr-2 text-indigo-600" />
                            <span className="text-lg font-medium text-gray-800 dark:text-gray-200">Adresse :</span>
                            <span className="ml-2 text-gray-600 dark:text-gray-200">
                                1454 Rue Malanda, {detail.owner.client.city}, {detail.owner.client.country}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Informations de Contact */}
            <div>
                {/* Actions et Vérifications */}
                    <div className="py-10">
                        

                        {/* Contacter */}
                        <div className="mt-4">
                        <button
                            className="w-full py-3 text-white transition duration-150 bg-indigo-700 rounded-lg hover:bg-indigo-800 "
                            onClick={() => nav(`/message/${detail.owner.client.email}/${`${detail.owner.client.firstname} ${detail.owner.client.lastname}`}`)}
                        >
                            Contacter
                        </button>
                        </div>
                </div>
            </div>

            {/* Modal de Validation */}
            <ValidationModal
                isOpen={open}
                demande={detail}
                onClose={() => setOpen(false)}
                onContact={() => nav(`/message/${detail.owner.client.email}/${`${detail.owner.client.firstname} ${detail.owner.client.lastname}`}`)}
                onValidate={async () => {
                    setShowAlert(true)
                }}
                onDelete={async () => {
                try {
                    await api.post('/owners/deleteDemand', {
                    id: detail.owner.id,
                    });
                } catch (error) {
                    console.error(error);
                }
                }}
            />


            

            {showAlert && <Confirm 
                open={showAlert}
                onClose={()=>setShowAlert(false)}
                onAccept={async ()=> await verified()}
                onDecline={()=>setShowAlert(false)}
                message={'Voulez vous accepter cette demande ?'}
            />}

            {confirmation && <Confirm 
                open={confirmation}
                onClose={()=>setShowConfirmation(false)}
                onAccept={async ()=> await unSuspening()}
                onDecline={()=>setShowConfirmation(false)}
                message={'Voulez vous debloquer ce proprietaire ?'}
            />}
            
            <AbstractModal open={openSus} setOpen={setOpenSus}>
                <SuspendClient client={detail.owner.client}/>
            </AbstractModal>

            <AbstractModal open={showPremiumModal} setOpen={setPremiumModal}>
                <AddToPremium owner={detail.owner}/>
            </AbstractModal>

            
            

        </div>

    );
}
